<div>
<job-description-lca-position-library [primaryData]="primaryData"
    [isForeignCompany]="isForeignCompany"></job-description-lca-position-library>
</div>